const routes = [
    {
        path: '/template-pruning',
        name: 'template-pruning',
        component: () => import('@/modules/managers/templatePruning/TemplatePruning.vue')
    }
]

export default routes
